var map = {
	"./ingredients-1.png": 2268,
	"./ingredients-10.png": 6835,
	"./ingredients-11.png": 3822,
	"./ingredients-12.png": 7793,
	"./ingredients-13.png": 2279,
	"./ingredients-14.png": 575,
	"./ingredients-2.png": 3258,
	"./ingredients-3.png": 8602,
	"./ingredients-4.png": 8100,
	"./ingredients-5.png": 2150,
	"./ingredients-6.png": 654,
	"./ingredients-7.png": 6527,
	"./ingredients-8.png": 9018,
	"./ingredients-9.png": 1525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4197;